import { resolveAppHeader } from './rules/app-header';
import { resolvePlanSelection } from './rules/checkout-session-modal';
import { resolveDashboard } from './rules/dashboard';
import { resolveNavigation } from './rules/navigation';
import { resolveOnboarding } from './rules/onboarding';
import { showSmbButton } from './rules/show-smb-button';
import { resolveSmbButton } from './rules/smb-button';
const UTM_SOURCE = 'helloDarwin';
const UTM_MEDIUM = 'client-app';
const MARKETING_BUTTON_CAMPAIGNS = {
    onboarding: 'app-onboarding',
    navigation: 'navigation',
    dashboard: 'dashboard',
    'app-header': 'app-header',
    'plan-selection': 'app-onboarding',
    'funding-explorer': 'funding-explorer',
    'grant-application': 'grant-application',
    'applications-kanban': 'applications-kanban',
};
export function appendMarketingButtonUtm(link, campaign) {
    if (!link)
        return link;
    const hashIndex = link.indexOf('#');
    const linkWithoutHash = hashIndex === -1 ? link : link.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : link.slice(hashIndex);
    const separator = linkWithoutHash.includes('?') ? '&' : '?';
    const params = new URLSearchParams({
        utm_source: UTM_SOURCE,
        utm_medium: UTM_MEDIUM,
        utm_campaign: campaign,
    });
    return `${linkWithoutHash}${separator}${params.toString()}${hash}`;
}
function withMarketingButtonUtm(config, campaign) {
    if (!config.link)
        return config;
    return Object.assign(Object.assign({}, config), { link: appendMarketingButtonUtm(config.link, campaign) });
}
function resolveGrantApplicationButton(selectedLocale, accessLevel, company) {
    if (!showSmbButton(selectedLocale, accessLevel, company)) {
        return {
            title: '',
        };
    }
    return Object.assign(Object.assign({}, resolveSmbButton(selectedLocale, company)), { title: selectedLocale === 'en'
            ? 'Apply with an expert'
            : 'Appliquez avec un expert' });
}
function resolveApplicationsKanbanButton(selectedLocale, accessLevel, company) {
    if (!showSmbButton(selectedLocale, accessLevel, company)) {
        return {
            title: '',
        };
    }
    return Object.assign(Object.assign({}, resolveSmbButton(selectedLocale, company)), { title: selectedLocale === 'en' ? 'Talk to an expert' : 'Parler à un expert' });
}
export function resolveMarketingButton(type, selectedLocale, accessLevel, company, admin, handleCheckout) {
    let config;
    switch (type) {
        case 'onboarding':
            config = resolveOnboarding(selectedLocale, accessLevel, company, admin);
            break;
        case 'navigation':
            config = resolveNavigation(selectedLocale, accessLevel, company, admin, handleCheckout);
            break;
        case 'dashboard':
            config = resolveDashboard(selectedLocale, accessLevel, company, admin, handleCheckout);
            break;
        case 'app-header':
            config = resolveAppHeader(selectedLocale, accessLevel, company, admin, handleCheckout);
            break;
        case 'plan-selection':
            config = resolvePlanSelection(selectedLocale, accessLevel, company, admin);
            break;
        case 'funding-explorer':
            if (!showSmbButton(selectedLocale, accessLevel, company)) {
                return {
                    title: '',
                };
            }
            config = resolveSmbButton(selectedLocale, company);
            break;
        case 'grant-application':
            config = resolveGrantApplicationButton(selectedLocale, accessLevel, company);
            break;
        case 'applications-kanban':
            config = resolveApplicationsKanbanButton(selectedLocale, accessLevel, company);
            break;
        default:
            config = resolveAppHeader(selectedLocale, accessLevel, company, admin, handleCheckout);
    }
    return withMarketingButtonUtm(config, MARKETING_BUTTON_CAMPAIGNS[type]);
}
